__turbopack_context__.v({
  "accordion": "details-module__8jfxTG__accordion",
  "blok-big-title": "details-module__8jfxTG__blok-big-title",
  "blok-subtitle": "details-module__8jfxTG__blok-subtitle",
  "blok-title": "details-module__8jfxTG__blok-title",
  "detailText": "details-module__8jfxTG__detailText",
  "details": "details-module__8jfxTG__details",
});
